import CustomNavbar from '../components/Navbar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SectionLR from '../components/SectionLR';
import CarouselS from '../components/Carousel-s';


  const slides1 = ["/images/mission.png"]
  const slides2 = ["/images/scales-justice-hand.jpg"]


function About() {

    return(
    <div>
        <CustomNavbar />
        <Header 
      title = "ABOUT US"
      subtext = "Eastern for trading is an Egyptian import and export company established in March, 2003,  focusing mainly on food ingredients for business to business, supplying our products in  Egypt and North Africa. We have become a distributor for Fuji Oil Asia in Early 2015. Our target is to become one of the leading companies in supplying food ingredients in the middle east. We have more than twenty years working in business to business, Especially in oil and fat products. During this period we built a strong customer base. The company's main office and the warehouses are in Alexandria besides the Cairo office."
      imgURL = "/images/melted-chocolate-swirl.jpg"    />


        <div className={"section "}>

            <div className="text dm1">
              <h3>MISSION</h3>           
                <p>Our mission is to build long lasting relationships with our customers by providing high quality products with the most reasonable prices. These relationships are always considered win-win situations, that's why our slogan is Let's Win Together.</p>
            </div>

        <CarouselS items={slides1} interval={3000}/>

        </div>



        <div className={"section "}>

            <div className="text dm1">
              <h3>QUALITIES</h3>
                           
            <ul>
               <li>Reliability</li>
               <li>High Quality Products</li>
               <li>Competitive Prices</li>
                <li>Short Service Time</li>
            </ul>
            </div>

        <CarouselS items={slides2} interval={3000}/>

        </div>


        <Footer />
    </div>
    )
}

export default About;




// import React from 'react';
// import CustomNavbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import Header from '../components/Header';

// import "../css/main.css"
// import "../css/about.css"


// function About() {


//   return (
//     <div>
    
//     <CustomNavbar />
//     <div className='empty-header'/>


//     <div className='text-left'>
//       <div className='text'>
//         <h1>MISSION</h1>
//         <p>Our mission is to build long lasting relationships with our customers by providing high quality products with the most reasonable prices. These relationships are always considered "win-win" situations, that's why our slogan is "Let's Win Together".</p>
//         </div>
//         <div className='image'>
//         <img src='/images/about/about-page-01.webp' alt=''></img>
//         </div>
//     </div>

//     <div className='text-left'>
//       <div className='text'>
//         <h1>QUALITIES</h1>
//        <ul>
//     <li>Reliability</li>
//     <li>High Quality Products</li>
//     <li>Competitive Prices</li>
//     <li>Short Service Time</li>
// </ul>
//         </div>
//         <div className='image'>
//         <img src='/images/about/about-page-02.webp' alt=''></img>
//         </div>
//     </div>




//     <Footer />
//     </div>

    
//   );
// }

// export default About;

